const time_key = "time";
const timeRange_key = "timeRange";

export { time_key, timeRange_key };
